module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"serialNumber":"Serial Number"},"ru":{"serialNumber":"Серийный номер"}}')
  delete Component.options._Ctor
}
